import http from './http';

export default {
  /**
   * Tasks Tab
   */
  getAssignedTasks(data) {
    return http().post(`/v1/stats_team/tasks/assigned_tasks`, data)
  },
  getCompletedTasks(data) {
    return http().post(`/v1/stats_team/tasks/completed_tasks`, data)
  },
  getCompletedLateTasks(data) {
    return http().post(`/v1/stats_team/tasks/completed_late_tasks`, data)
  },
  getIncompleteTasks(data) {
    return http().post(`/v1/stats_team/tasks/incomplete_tasks`, data)
  },
  getIncompleteAndPastDueTasks(data) {
    return http().post(`/v1/stats_team/tasks/incomplete_past_due_tasks`, data)
  },
  getCompletionRateTasks(data) {
    return http().post(`/v1/stats_team/tasks/completion_rate_tasks`, data)
  },

  /**
   * Comms Tab
   */
  getCallsMade(data) {
    return http().post(`/v1/stats_team/comms/calls_made`, data)
  },
  getSmsSent(data) {
    return http().post(`/v1/stats_team/comms/sms_sent`, data)
  },
  getEmailsSent(data) {
    return http().post(`/v1/stats_team/comms/emails_sent`, data)
  },
  getInboundAddressed(data) {
    return http().post(`/v1/stats_team/comms/inbound_addressed`, data)
  },

  /**
   * Lead Intake Tab
   */
  getLeadsCreatedManually(data) {
    return http().post(`/v1/stats_team/lead_intake/leads_created_manually`, data)
  },
  getAssignedLeads(data) {
    return http().post(`/v1/stats_team/lead_intake/assigned_leads`, data)
  },
  getAppointmentsSets(data) {
    return http().post(`/v1/stats_team/lead_intake/appointments_sets`, data)
  },

  /**
   * Acquisitions Tab
   */
  getAppointmentsAssigned(data) {
    return http().post(`/v1/stats_team/acquisitions/appointments_assigned`, data)
  },
  getAppointmentsCancelledByUs(data) {
    return http().post(`/v1/stats_team/acquisitions/appointments_cancelled_by_us`, data)
  },
  getAppointmentsCancelledByLead(data) {
    return http().post(`/v1/stats_team/acquisitions/appointments_cancelled_by_lead`, data)
  },
  getContracts(data) {
    return http().post(`/v1/stats_team/acquisitions/contracts`, data)
  },
  getBought(data) {
    return http().post(`/v1/stats_team/acquisitions/bought`, data)
  },
  getSold(data) {
    return http().post(`/v1/stats_team/acquisitions/sold`, data)
  },
  getProjectedProfit(data) {
    return http().post(`/v1/stats_team/acquisitions/projected_profit`, data)
  },
  getActualProfit(data) {
    return http().post(`/v1/stats_team/acquisitions/actual_profit`, data)
  },
}
